export const DEFAULT_DENT = 14
import { GAP_SIZE } from '../chart_helpers/AxisHelper'

export function dentedRect(w, h, options = {}) {
  let { dents, gapStart, forcedDentSize, offsets, lengths, barWidth, horizontal } = options
  if (!offsets) offsets = { tl: 0, tr: 0, bl: 0, br: 0 }
  if (!lengths) lengths = { tl: 0, tr: 0, bl: 0, br: 0 }
  // let r = Math.floor(Math.min(Math.min(w/3,h/3),forcedDentSize))
  let r

  if (forcedDentSize !== undefined) r = forcedDentSize
  else r = Math.floor(Math.min(barWidth / 2, DEFAULT_DENT))

  // let r = 30
  if (!Array.isArray(dents)) dents = [dents]
  // let r_tl = dents.indexOf('tl')>=0?r:0
  // let r_tr = dents.indexOf('tr')>=0?r:0
  // let r_bl = dents.indexOf('bl')>=0?r:0
  // let r_br = dents.indexOf('br')>=0?r:0

  let gapPath = ''
  if (gapStart) {
    let dG, gH, ddG, gOffset

    if (h > w) {
      dG = Math.min(w / 2, gapStart - 5)
      gH = Math.max(4, Math.min(6, dG / 2))
      ddG = dG / 2
      gOffset = gapStart - gH / 2 - dG / 2
      // gapPath = `M 0 ${gOffset} L ${w} ${gOffset} L ${w} ${gOffset+gH} L 0 ${gOffset+gH} L 0 ${gOffset}`
      gapPath = `M 0 ${gOffset} 
              c ${w / 2 - ddG - 5} ${dG - ddG}, ${w / 2 + ddG} ${ddG}, ${w} ${dG}
              l 0 ${gH} 
              c ${-w / 2 + ddG + 5} ${-dG + ddG}, ${-w / 2 - ddG} ${-ddG}, ${-w} ${-dG}
              l 0 -${gH}`
    } else {
      dG = Math.min(h / 2, -gapStart + 5)
      gH = Math.max(3, Math.min(6, dG / 2))
      ddG = dG / 2
      gOffset = w + gapStart + gH / 2 + dG / 2
      // gapPath = `M ${gOffset} 0 L ${gOffset+gH} 0 L ${gOffset+gH} ${h} L ${gOffset} ${h} L ${gOffset} 0 `
      gapPath = `M ${gOffset} 0
              c ${-ddG} ${h / 2 - ddG - 5}, ${-dG + ddG} ${h / 2 + ddG} , ${-dG} ${h}
              l ${-gH} 0 
              c ${ddG} ${-h / 2 + ddG + 5}, ${+dG - ddG} ${-h / 2 - ddG} , ${dG} ${-h}
              l ${gH} 0 `
    }
  }

  // return `M 0 ${r_tl}
  //         v ${h-r_bl-r_tl}  a ${r_bl} ${r_bl} 1 0 0 ${r_bl}  ${r_bl}
  //         h ${w-r_bl-r_br}  a ${r_br} ${r_br} 1 0 0 ${r_br}  ${-r_br}
  //         v ${-h+r_br+r_tr} a ${r_tr} ${r_tr} 1 0 0 ${-r_tr} ${-r_tr}
  //         h ${-w+r_tr+r_tl} a ${r_tl} ${r_tl} 1 0 0 ${-r_tl} ${r_tl}`+
  //         gapPath

  //HALFWAY//
  // let re_tl_y_1 = Math.min(r_tl,h) - offset
  // let re_tl_y = r_tl-re_tl_y_1 - offset
  // let re_tl_x = Math.sqrt(r_tl*r_tl-re_tl_y*re_tl_y)
  // let re_tl_x_1 = r_tl-re_tl_x

  // return `M ${re_tl_x_1} ${re_tl_y_1}
  //         h ${-re_tl_x_1}
  //         v ${h-r_bl-re_tl_y_1} a ${r_bl} ${r_bl} 1 0 0 ${r_bl}  ${r_bl}
  //         h ${w-r_bl-r_br}  a ${r_br} ${r_br} 1 0 0 ${r_br}  ${-r_br}
  //         v ${-h+r_br+r_tr} a ${r_tr} ${r_tr} 1 0 0 ${-r_tr} ${-r_tr}
  //         h ${-w+r_tr+r_tl} a ${r_tl} ${r_tl} 1 0 0 ${-re_tl_x} ${re_tl_y_1}
  //         h ${-re_tl_x_1}
  //         `+
  //         gapPath

  // offset = 5
  // r_tl = 30

  //HAY QUE HACERLO CON "forEach (tl,tr,bl,br) con un "dir=[1,-1] o similar

  let points = {}

  let keys = ['bl', 'br', 'tr', 'tl']
  let defs = {
    bl: {
      // x:(x)=>x,
      // y:(y)=>h-y,
      transform: ({ xi, xf, yi, yf }) => {
        return { xi: yi, xf: yf, yi: h - xi, yf: h - xf }
      },
      offset: offsets.bl,
      length: lengths.bl,
    },
    br: {
      // x:(x)=>w-x,
      // y:(y)=>h-y,
      transform: ({ xi, xf, yi, yf }) => {
        return { xi: w - xi, xf: w - xf, yi: h - yi, yf: h - yf }
      },
      offset: offsets.br,
      length: lengths.br,
    },
    tr: {
      // x:(x)=>w-x,
      // y:(y)=>y,
      transform: ({ xi, xf, yi, yf }) => {
        return { xi: w - yi, xf: w - yf, yi: xi, yf: xf }
      },
      offset: offsets.tr,
      length: lengths.tr,
    },
    tl: {
      // x:(x)=>x,
      // y:(y)=>y,
      transform: ({ xi, xf, yi, yf }) => {
        return { xi, xf, yi, yf }
      },
      offset: offsets.tl,
      length: lengths.tl,
    },
  }
  keys.forEach(key => {
    let offset = defs[key].offset
    let length = defs[key].length
    let ri = dents.indexOf(key) >= 0 ? r : 0
    // Basurilla, no entiendo porqeu a los "14" tambien tengo que aplicarles un 0.001 => 13.999
    // Pero "sino" no anima bien
    offset = Math.max(offset, 0.001)
    // end of Basurilla
    if (offset > ri || offset < 0) {
      offset = 0
      ri = 0
    }
    let y_arc = Math.min(ri - offset, length)
    let xcs = ri - offset
    let xc1 = Math.sqrt(ri * ri - xcs * xcs)
    let xi = ri - xc1

    let xce = ri - y_arc - offset
    let xc2 = Math.sqrt(ri * ri - xce * xce)
    let xf = ri - xc2
    let yi = 0
    let yf = y_arc
    if (isNaN(xi)) {
      console.log(xi)
    }
    // xi = defs[key].x(xi)
    // xf = defs[key].x(xf)
    // y_arc = defs[key].y(y_arc)
    ;({ xi, xf, yi, yf } = defs[key].transform({ xi, xf, yi, yf }))
    points[key] = {
      xi,
      xf,
      yi,
      yf,
      // y_arc
    }
  })

  //BASURILLA; no he conseguido hacerlo bien, porlo que al final:
  // en vertical: se pone tl+br como siempre
  // en horiztonal: se ponen tr+bl, y luego se "flipea"
  // Me he cargado los "max/min" del path, poqrque ya "o es un caso o es el otro"...
  let sweepFlag = 0
  if (horizontal) {
    sweepFlag = 1
    Object.keys(points).forEach(k => {
      let p = points[k]
      p.yi = h - p.yi
      p.yf = h - p.yf
    })
    return (
      `M ${points.tl.xf} ${points.tl.yf} 
              V ${points.bl.yi}
              A ${r} ${r} 1 0 ${sweepFlag} ${points.bl.xf} ${points.bl.yf}
              H ${points.br.xi} 
              A ${r} ${r} 1 0 ${sweepFlag} ${points.br.xf} ${points.bl.yf}
              V ${points.tr.yi}
              A ${r} ${r} 1 0 ${sweepFlag} ${points.tr.xf} ${points.tr.yf}
              H ${points.tl.xi}
              A ${r} ${r} 1 0 ${sweepFlag} ${points.tl.xf} ${points.tr.yf}` + gapPath
    )
  } else {
    return (
      `M ${points.tl.xf} ${points.tl.yf} 
                    V ${points.bl.yi}
                    A ${r} ${r} 1 0 ${sweepFlag} ${points.tl.xf} ${points.bl.yf}
                    H ${points.br.xi} 
                    A ${r} ${r} 1 0 ${sweepFlag} ${points.br.xf} ${points.br.yf}
                    V ${points.tr.yi}
                    A ${r} ${r} 1 0 ${sweepFlag} ${points.br.xf} ${points.tr.yf}
                    H ${points.tl.xi}
                    A ${r} ${r} 1 0 ${sweepFlag} ${points.tl.xf} ${points.tl.yf}` + gapPath
    )
  }
  // return `M ${points.tl.xf} ${points.tl.yf}
  //           V ${points.bl.yi}
  //           A ${r} ${r} 1 0 ${sweepFlag} ${Math.max(points.tl.xf,points.bl.xf)} ${points.bl.yf}
  //           H ${points.br.xi}
  //           A ${r} ${r} 1 0 ${sweepFlag} ${points.br.xf} ${Math.min(points.br.yf,points.bl.yf)}
  //           V ${points.tr.yi}
  //           A ${r} ${r} 1 0 ${sweepFlag} ${Math.min(points.br.xf,points.tr.xf)} ${points.tr.yf}
  //           H ${points.tl.xi}
  //           A ${r} ${r} 1 0 ${sweepFlag} ${points.tl.xf} ${Math.max(points.tr.yf,points.tl.yf)}`+
  //           gapPath
}

export function tweenDentedRect(d, options) {
  let { barLength, barWidth, longDir, scale, gapStart } = options
  let dy1 = d.y1 !== undefined ? d.y1 : d.value //(d.y1 || d.value)
  let dy0 = d.y0 !== undefined ? d.y0 : 0 //(d.y0 || 0)
  let dBarMax = d.barMax !== undefined ? d.barMax : d.value //(d.barMax || d.value)
  let dBarMin = d.barMin !== undefined ? d.barMin : 0 //(d.barMin || 0)
  let width = longDir === 'width' ? barWidth : barLength
  let height = longDir === 'width' ? barLength : barWidth
  let startL = this._currentL !== undefined ? this._currentL : 0
  let startY1 = this._currentY1 !== undefined ? this._currentY1 : dy1
  let startY0 = this._currentY0 !== undefined ? this._currentY0 : dy0
  let startBarMax = this._currentBarMax !== undefined ? this._currentBarMax : dBarMax
  let startBarMin = this._currentBarMin !== undefined ? this._currentBarMin : dBarMin
  let startW = this._currentW !== undefined ? this._currentW : longDir === 'width' ? barWidth : 0
  let startH = this._currentH !== undefined ? this._currentH : longDir === 'width' ? 0 : barWidth
  let startBw = this._currentBw !== undefined ? this._currentBw : barWidth

  return t => {
    let l = startL + (barLength - startL) * t
    let w = startW + (width - startW) * t
    let h = startH + (height - startH) * t
    let y1 = startY1 + (dy1 - startY1) * t
    let y0 = startY0 + (dy0 - startY0) * t
    let max = startBarMax + (dBarMax - startBarMax) * t
    let min = startBarMin + (dBarMin - startBarMin) * t
    let bw = startBw + (barWidth - startBw) * t
    this._currentL = l
    this._currentY1 = y1
    this._currentY0 = y0
    this._currentBarMax = max
    this._currentBarMin = min
    this._currentW = w
    this._currentH = h
    this._currentBw = bw
    let diffMax
    let diffMin
    let dents = []
    let offsets
    let lengths
    if (longDir === 'height') {
      diffMax = scale(max) - scale(y1)
      diffMin = scale(y0) - scale(min)
      dents.push('tr')
      dents.push('bl')
      offsets = { tl: 0, tr: diffMax, br: 0, bl: diffMin }
      lengths = { tl: 0, tr: l, br: 0, bl: l }
    } else {
      diffMax = scale(y1) - scale(max)
      diffMin = scale(min) - scale(y0)
      dents.push('tl')
      dents.push('br')
      offsets = { tl: diffMax, tr: 0, br: diffMin, bl: 0 }
      lengths = { tl: l, tr: 0, br: l, bl: 0 }
    }
    return dentedRect(
      // longDir === 'width'?w:l,
      // longDir === 'width'?l:h,
      w,
      h,
      {
        dents,
        offsets,
        lengths,
        barWidth: bw,
        gapStart,
        horizontal: longDir !== 'width',
      }
    )
  }
}
